import { CreditApi } from "queries/Credit";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import React from "react";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { Loading } from "components/panels";
import { AddCreditModal } from "./AddCreditModal";
import { useQueryClient } from "@tanstack/react-query";
import { formatCurrency } from "utilities";

interface Props {
  clientId: number;
}

export const CreditPanel = (props: Props) => {
  const [displayAddCreditModal, setDisplayAddCreditModal] = React.useState(false);
  const creditsApi = CreditApi.GetCreditAccountByClient.useQuery({ clientId: props.clientId }, {});

  const queryClient = useQueryClient();

  const onClose = () => {
    queryClient.invalidateQueries(CreditApi.GetCreditAccountByClient.getCacheKey({ clientId: props.clientId }));
    setDisplayAddCreditModal(false);
  }

  return <SectionPanel.Panel
    header={<>
      <PanelSegmentType.Title title={"Credits"} />
      <PanelSegmentType.Button onClick={() => setDisplayAddCreditModal(true)} label={RESX.Buttons.btnNew} type="secondary" />
    </>}
  >
    <div className="ui message purple">
      {(creditsApi.data?.data.balance.amount != null && formatCurrency(creditsApi.data?.data.balance.amount, "eur", serverReference.culture.uiLocale)) ?? <Loading />}
    </div>

    {displayAddCreditModal && <AddCreditModal clientId={props.clientId} onClose={() => { setDisplayAddCreditModal(false); onClose(); }} />}
  </SectionPanel.Panel>
}